<template>
  <b-container fluid class="faq">
    <b-row>
      <b-col>
        <div class="faq-content">
          <img src="@/assets/rebrand/home/FAQ.png" alt="faq title" class="img-faq-title" />
          <b-row>
            <b-col cols="7" class="-wb ml-auto">
              <div class="accordion" role="tablist">
                <p class="faq-title">Getting Started</p>
                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-1>How do I connect my wallet? </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        Sign up with your Google account on ongaia.com and verify your account. Upon sign in, go to "My Wallet" to add funds or connect your credit card.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-2>How do I mint a Side Kick? </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        Join the SNKRHUD Discord server ASAP to get live updates of the minting schedule. Once live, <a href="">"Mint Now"</a> the  button on the SNKRHUD website will be available to redirect you to the marketplace.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-3
                      >Can I download the app straight from the App Store?
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        The SNKRHUD app will be available to all Side Kicks Holders in the weeks
                        following our successful sell out.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-4>How do I access the app?</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text
                        >The app will be available in the Apple App Store and Google Play
                        Store.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-5>What is SNKRHUD? </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text
                        >SNKRHUD is an NFT-based playground for sneakerheads to immortalize their
                        personal<br />
                        collection in the form of digital collectibles they can collect, create, and
                        compete.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>

              <div class="accordion" role="tablist">
                <p class="faq-title">NFT</p>
                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-6>What is a NFT? </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        An NFT is a non-fungible token, often in the form of a digital collectible
                        with various traits that differentiate it from others and can determine its
                        value.</b-card-text
                      >
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>

              <div class="accordion" role="tablist">
                <p class="faq-title">Assets</p>
                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-7>How do assets work in SNKRHUD?</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        Side Kick NFT's unlock access to the SNKRHUD platform, while the DED Stock
                        Creator allows anyone to create their own NFT's based on photos of their
                        sneakers.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-8>What is a DED Stock?</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        A DED Stock is a virtual representation of the kicks in each Resident’s
                        Collection.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-9
                      >How do you use your DED Stock?
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        DED Stock not only allows you to own a virtual piece of your collection,
                        they also power Battle Bots, allowing you to compete in Bot-to-Bot Battles.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>

              <div class="accordion" role="tablist">
                <p class="faq-title">Plot Characters</p>
                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-10
                      >How many Side Kicks will be available?
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-10" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        Each Season, a new Faction of Side Kicks comes online. The first Faction of
                        Meerkats is 4280 Side Kicks.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-11>What are Side Kicks? </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-11" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        Side Kicks are animal companions that undergo rigorous physical conditioning
                        and specialized sneaker training powered by SNKRHUD.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <!-- <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-12
                      >How many Side Kicks will be available in the First Faction?
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-12" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text> First Faction will consist of 4280 Meerkats.</b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card> -->

                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-13>
                      How many Rarity Traits will each Side Kick have?
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-13" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text
                        >Side Kicks have 8 Rarity Traits including Background Environments, Fur
                        Types, Facial Expressions, Masks, Neck Scarfs, Body Armor, Battle Wraps, and
                        Tail Tools.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-14
                      >When will the Side Kicks be released?
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-14" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        Pre Sale begins May 2022.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-15>What is Rarity based upon? </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-15" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        There are five levels:
                        <ul>
                          <li>
                            Common
                          </li>
                          <li>Epic</li>
                          <li>Legendary</li>
                          <li>Rare</li>
                          <li>Super Rare</li>
                        </ul>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <!-- <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-16
                      >When will the Side Kicks be released?
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-16" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        Side Kicks are algorithmically generated from more than 100 hand drawn
                        pieces <br />
                        inspired by your favorite sneaker & streetwear labels.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card> -->

                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-19
                      >How are Side Kicks generated?
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-19" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        Side Kicks are algorithmically generated from more than 100 hand drawn
                        pieces inspired by your favorite sneaker & streetwear labels.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-17>Where can I find Side Kicks? </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-17" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        Side Kicks will be available to mint exclusively on the GAIA marketplace.
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body>
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-18
                      >How much will it cost to mint a Side Kick?
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-18" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>Pre Sale $250, Public Sale $300. </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>

            <!-- MOBILE -->
            <b-col class="-mb">
              <b-button v-b-toggle.getting-started class="btn-collapse-mobile"
                >Getting Started</b-button
              >

              <b-collapse id="getting-started">
                <div>
                  <div class="accordion" role="tablist">
                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-1
                          >How do I connect my wallet?
                        </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            Sign up with your Google account on ongaia.com and verify your account. Upon sign in, go to "My Wallet" to add funds or connect your credit card.
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-2 variant="info"
                          >How do I mint a Side Kick?</b-button
                        >
                      </b-card-header>
                      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            Join the SNKRHUD Discord server ASAP to get live updates of the minting schedule. Once live, the "Mint Now" button on the SNKRHUD website will be available to redirect you to the marketplace.
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-3
                          >Can I download the app straight from the App Store?
                        </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            The SNKRHUD app will be available to all Side Kicks Holders in the weeks
                            following our successful sell out.
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-4>How do I access the app?</b-button>
                      </b-card-header>
                      <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text
                            >The app will be available in the Apple App Store and Google Play
                            Store.</b-card-text
                          >
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-5>What is SNKRHUD? </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text
                            >SNKRHUD is an NFT-based playground for sneakerheads to immortalize
                            their personal<br />
                            collection in the form of digital collectibles they can collect, create,
                            and compete.</b-card-text
                          >
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                </div>
              </b-collapse>

              <b-button v-b-toggle.nft class="btn-collapse-mobile">NFT</b-button>

              <b-collapse id="nft">
                <div>
                  <div class="accordion" role="tablist">
                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-6>What is a NFT? </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            An NFT is a non-fungible token, often in the form of a digital
                            collectible with various traits that differentiate it from others and
                            can determine its value.</b-card-text
                          >
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                </div>
              </b-collapse>

              <b-button v-b-toggle.assets class="btn-collapse-mobile">Assets</b-button>

              <b-collapse id="assets">
                <div>
                  <div class="accordion" role="tablist">
                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-7
                          >How do assets work in SNKRHUD?</b-button
                        >
                      </b-card-header>
                      <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            Side Kick NFT's unlock access to the SNKRHUD platform, while the DED
                            Stock Creator allows anyone to create their own NFT's based on photos of
                            their sneakers.
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-8>What is a DED Stock?</b-button>
                      </b-card-header>
                      <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            A DED Stock is a virtual representation of the kicks in each Resident’s
                            Collection.
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-9
                          >How do you use your DED Stock?
                        </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            DED Stock not only allows you to own a virtual piece of your collection,
                            they also power Battle Bots, allowing you to compete in Bot-to-Bot
                            Battles.
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                </div>
              </b-collapse>

              <b-button v-b-toggle.plotcharacters class="btn-collapse-mobile"
                >Plot/Characters</b-button
              >

              <b-collapse id="plotcharacters">
                <div>
                  <div class="accordion" role="tablist">
                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-10
                          >How many Side Kicks will be available?
                        </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-10" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            Each Season, a new Faction of Side Kicks comes online. The first Faction
                            of Meerkats is 4280 Side Kicks.
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-11>What are Side Kicks? </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-11" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            Side Kicks are animal companions that undergo rigorous physical
                            conditioning and specialized sneaker training powered by SNKRHUD.
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <!-- <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-12
                          >How many Side Kicks will be available in the First Faction?
                        </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-12" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text> First Faction will consist of 4280 Meerkats.</b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card> -->

                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-13>
                          <span class="d-none d-md-block"
                            >How many Rarity Traits will each Side Kick have?</span
                          >
                          <span class="d-block d-md-none"
                            >How many Rarity Traits will <br />each Side Kick have?</span
                          >
                        </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-13" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text
                            >Side Kicks have 8 Rarity Traits including Background Environments, Fur
                            Types, Facial Expressions, Masks, Neck Scarfs, Body Armor, Battle Wraps,
                            and Tail Tools.
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-14
                          >When will the Side Kicks be released?
                        </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-14" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            Pre Sale begins May 2022.
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-15
                          >What is Rarity based upon?
                        </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-15" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            There are five levels:
                            <ul>
                              <li>
                                Common
                              </li>
                              <li>Epic</li>
                              <li>Legendary</li>
                              <li>Rare</li>
                              <li>Super Rare</li>
                            </ul>
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <!-- <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-16
                          >When will the Side Kicks be released?
                        </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-16" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            Side Kicks are algorithmically generated from more than 100 hand drawn
                            pieces <br />
                            inspired by your favorite sneaker & streetwear labels.
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card> -->

                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-19
                          >How are Side Kicks generated?
                        </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-19" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            Side Kicks are algorithmically generated from more than 100 hand drawn
                            pieces inspired by your favorite sneaker & streetwear labels.
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-17
                          >Where can I find Side Kicks?
                        </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-17" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>
                            Side Kicks will be available to mint exclusively on the GAIA marketplace.
                          </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body>
                      <b-card-header header-tag="header" role="tab">
                        <b-button block v-b-toggle.accordion-18
                          >How much will it cost to mint a Side Kick?
                        </b-button>
                      </b-card-header>
                      <b-collapse id="accordion-18" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>Pre Sale $250, Public Sale $300. </b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                </div>
              </b-collapse>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <img src="@/assets/rebrand/home/faq-list-bg.png" alt="faq list" class="img-faq-list -wb" />
    <img src="@/assets/rebrand/home/faq-overlay.png" alt="faq" class="faq-overlay -wb" />
  </b-container>
</template>
<script>
export default {
  name: 'Faq',
};
</script>
